// import { useState, useEffect, useMemo, useCallback } from 'react';
// import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
// import { db } from '../../../firebase/config';
// import { useUser } from '../../../contexts/UserContext';

// const useCanAccess = (tripId: string, allowedRoles: string[]) => {
//    const [access, setAccess] = useState({ canAccess: false, message: '' });
//    const { currentUser: user } = useUser();

//    // Memoize allowedRoles to prevent unnecessary re-renders
//    const allowedRolesMemo = useMemo(() => allowedRoles, [JSON.stringify(allowedRoles)]);

//    const checkAccess = useCallback(async () => {
//       if (!tripId || !user) {
//          setAccess({ canAccess: false, message: 'Invalid trip id' });
//          return;
//       }

//       try {
//          const tripRef = doc(db, 'trips', tripId); // Correct way to reference a document
//          const tripSnap = await getDoc(tripRef);

//          if (!tripSnap.exists()) {
//             setAccess({ canAccess: false, message: 'Trip not found' });
//             return;
//          }

//          const tripData = tripSnap.data() as any;
//          console.log(tripData, 'data');
//          const collaborators = tripData.collaborators || [];
//          const userCollab = collaborators.find((c: any) => c.email === user.email);

//          if (!userCollab || !allowedRolesMemo.includes(userCollab.status)) {
//             setAccess({
//                canAccess: false,
//                message: `Do not have access as ${userCollab?.status}`,
//             });
//          } else {
//             setAccess({ canAccess: true, message: '' });
//          }
//       } catch (error) {
//          console.log(error);
//          setAccess({ canAccess: false, message: 'Error checking access' });
//       }
//    }, [tripId, user, allowedRolesMemo]);

//    useEffect(() => {
//       checkAccess();
//    }, [checkAccess]);

//    return { access };
// };

// export default useCanAccess;

import { useState, useEffect, useCallback } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { useUser } from '../../../contexts/UserContext';

interface AccessState {
   canAccess: boolean;
   message: string;
}

const useCanAccess = (collectionName: string, documentId: string) => {
   const [tripData, setTripData] = useState<any>(null);

   const { currentUser: user } = useUser();

   useEffect(() => {
      const fetchTrip = async () => {
         if (!documentId) return;

         try {
            const docRef = doc(db, collectionName, documentId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
               setTripData(docSnap.data());
            } else {
               setTripData(null);
            }
         } catch (error) {
            console.error('Error fetching trip:', error);
            setTripData(null);
         } finally {
         }
      };

      fetchTrip();
   }, [collectionName, documentId]);

   const canUserAccess = (allowedRoles: string[]): { canAccess: boolean; message: string } => {
      if (!tripData) {
         return { canAccess: false, message: 'Trip not found ' };
      }

      if (!user) {
         return { canAccess: false, message: 'User not found' };
      }

      const collaborators = tripData.collaborators || [];
      const userCollab = collaborators.find((c: any) => c.email === user.email);

      if (!userCollab) {
         return { canAccess: false, message: `You can't access as ${userCollab?.status}` };
      }

      if (!allowedRoles.includes(userCollab.status)) {
         return {
            canAccess: false,
            message: `Access denied: You are a ${userCollab.status}`,
         };
      }

      return { canAccess: true, message: '' };
   };

   return { canUserAccess };
};

export default useCanAccess;
